import { Box, Typography } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../../../src/components/common/Breadcrumbs.jsx";
import LoanFormPopupV2 from "../../../src/Drawer/LoanFormPopupV2.jsx";
import { MemoizedConnectDrawer } from "../../../src/Drawer/connectDrawer.jsx";
import {
  generateItemListSchema,
  createListItem,
} from "../../../src/utils/ItemListSchema.js";
import {
  mahindraPrdouctSchema,
  piaggioPrdouctSchema,
} from "../../../src/constants/productSchema.js";
import {
  searchWebSiteVehicles,
  webPageSpeakableVehicles,
} from "../../../src/constants/siteLinksSchems.js";
import { convertFAQsToQuestions, generateFAQPageSchema } from "../../../src/utils/FAQPageSchemaGenerator.js";
import {
  BrandLogos,
  newVehicles,
  ThreeWheelerPassenegerBrandLogos,
  vehicles,
} from "../../../src/constants/vehicleData.js";
import { imagesWEBP } from "../../../src/constants/webpImages.js";
import { MemoizedFooter } from "../../../src/layouts/footer.jsx";
import { MemoizedHeader } from "../../../src/layouts/header.jsx";
import WhatsAppFloater from "../../../src/modules/Brand/WhatAppFloater.js";
import BookEVConsultationForm from "../../../src/modules/Home/BookEVconsult/bookEVConsultation.jsx";
import FullscreenDrawer from "../../../src/modules/Home/HomePageRevamp/VehicleSlideDrawer.jsx";
import { MemoizedFAQ } from "../../../src/modules/Lead Capture/FAQ/faq.jsx";
import QlDrawerComponent from "../../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents.jsx";
import MemoizedTopBanner from "../../../src/modules/Vehicles/Banner/BannerGeneric.jsx";
import BrandLogoTile from "../../../src/modules/Vehicles/Banner/BrandLogoTile.jsx";
import AtfContentSection from "../../../src/components/common/ContentTemplates/AtfContentSection.jsx";
import SeoContentSection from "../../../src/components/common/ContentTemplates/SeoContentSection.jsx";
import SeoContentRenderer from "../../../src/components/common/ContentTemplates/SeoContentRenderer.jsx";
import { MemoizedVehicles } from "../../../src/modules/Vehicles/Vehicles.jsx";
import MemoizedSearchHeader from "../../../src/modules/Vehicles/searchHeader.jsx";
import { sendAnalytics } from "../../../src/utils/analyticsCommon.jsx";
import {
  TITLE,
  META_CONTENT,
  VEHICLE_LINK,
  H1_HEADING,
  ATF_CONTENT,
  PRICING_TABLE_HEADING,
  PRICING_TABLE_COLUMNS,
  PRICING_TABLE_DATA,
  SEO_FOOTER_CONTENT,
  CARGO_FAQS,
  CONNECT_HEADING,
  CONNECT_SUBHEADING,
  CONNECT_CTA_TEXT,
  BREADCRUMB_ITEMS,
  BREADCRUMB_SCHEMA,
} from "../../../src/constants/electricCargoVehicle/index.js";
export default function ElectricCommercialVehicle({ vehiclesByBrand, itemListSchema, faqPageSchema, BrandLogos: filteredBrandLogos }) {
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: "electric_commercial_vehicle_cargo" },
      "en"
    );
  }, []);

  return (
    <>
      <Head>
        <title>{TITLE}</title>
        {META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        <meta name="google-site-verification" content="Z4WHXzpop_N_b6hE5g7A0fCENRwj5VqC3nSEsXLaQ3Y" />
        <link rel="canonical" href={VEHICLE_LINK} />
        <link rel="icon" href="/favicon.png" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
        {/* FAQPage Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqPageSchema),
          }}
          defer
        />
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(webPageSpeakableVehicles),
          }}
          defer
        /> */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(searchWebSiteVehicles),
          }}
          defer
        /> */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(piaggioPrdouctSchema),
          }}
          defer
        /> */}
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(mahindraPrdouctSchema),
          }}
          defer
        /> */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(itemListSchema),
          }}
          defer
        />
      </Head>
      <body>
        <Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader />
          </Box>
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <MemoizedSearchHeader isProductPage={true} />
          </Box>
          <FullscreenDrawer />
          <LoanFormPopupV2 />
          <QlDrawerComponent />
          <MemoizedTopBanner
            bannerData={{
              desktopImg: imagesWEBP?.vehiclePageBanner,
              mobileImg: imagesWEBP?.electricPasengeterBanner,
              altText: "Electric Cargo Vehicles banner",
            }}
          />

          <Box sx={{ display: { sm: "block", md: "none", lg: "none" } }}>
            {" "}
            <BookEVConsultationForm />
          </Box>

          <Typography
            variant="h1"
            style={{ fontSize: "34px", fontWeight: 700, paddingLeft: "8%" }}
          >
            {H1_HEADING}
          </Typography>

          {/* ATF Content */}
          <AtfContentSection
            content={ATF_CONTENT}
            tableData={{
              type: "pricing",
              heading: PRICING_TABLE_HEADING,
              columns: PRICING_TABLE_COLUMNS,
              data: PRICING_TABLE_DATA,
            }}
          />

          <BrandLogoTile brand="" BrandLogos={filteredBrandLogos || []} />
          <MemoizedVehicles vehiclesByBrand={vehiclesByBrand} />
          
          {/* SEO Footer Content with Read More/Less */}
          <SeoContentSection>
            <SeoContentRenderer content={SEO_FOOTER_CONTENT} />
          </SeoContentSection>

          <MemoizedFAQ faqList={CARGO_FAQS} />
          <WhatsAppFloater />
          <MemoizedConnectDrawer
            heading={CONNECT_HEADING}
            subHeading={CONNECT_SUBHEADING}
            ctaText={CONNECT_CTA_TEXT}
          />
          <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
            <Breadcrumbs items={BREADCRUMB_ITEMS} />
          </Box>
          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
}
export const getStaticProps = (context) => {
  let allVehicles = [...vehicles, ...newVehicles];
  const updatedVehiclesByBrand = {};
  let cargoVehicles = allVehicles.filter(vehicle => vehicle.type !== "passenger");
  //soting vehicles by brands
  cargoVehicles?.forEach((vehicle) => {
    const brand = vehicle?.brand?.toLowerCase();
    // Exclude Eka, Altigreen, and Etrio brands
    if (brand === "eka" || brand === "altigreen" || brand === "etrio") {
      return;
    }
    if (!updatedVehiclesByBrand?.hasOwnProperty(brand)) {
      updatedVehiclesByBrand[brand] = [];
    }
    updatedVehiclesByBrand[brand]?.push(vehicle);
  });

  // Generate ItemList Schema for cargo vehicles
  const itemListSchema = generateItemListSchema({
    name: "Electric Cargo Vehicles",
    description: "List of electric cargo commercial vehicles available at Turno",
    itemListElement: cargoVehicles.map((vehicle, index) => {
      const vehicleUrl = vehicle.vehicle_path_id 
        ? `https://www.turno.club/electric-commercial-vehicles/${vehicle.brand}/${vehicle.vehicle_path_id}`
        : `https://www.turno.club/electric-commercial-vehicles/${vehicle.brand}`;
      
      return createListItem({
        position: index + 1,
        name: vehicle.name || vehicle.vehicle_name || `${vehicle.brand} ${vehicle.vehicle_path_id}`,
        url: vehicleUrl,
        description: vehicle.meta_description || vehicle.page_title || `${vehicle.brand} ${vehicle.vehicle_name || vehicle.vehicle_path_id} electric cargo vehicle`,
        image: vehicle.image || vehicle.storeImage || vehicle.homeImage,
      });
    }),
    itemListOrder: "Ascending",
    numberOfItems: cargoVehicles.length,
    url: VEHICLE_LINK,
  });

  // Generate FAQPage Schema from CARGO_FAQS
  const faqQuestions = convertFAQsToQuestions(CARGO_FAQS || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: "FAQs on Electric Cargo Vehicles",
    description: `Frequently asked questions about electric cargo commercial vehicles.`,
    url: VEHICLE_LINK,
    headline: "FAQs on Electric Cargo Vehicles",
    keywords: META_CONTENT[1]?.content || "Electric Cargo Vehicles, FAQ, electric loading auto",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: BREADCRUMB_SCHEMA,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: imagesWEBP?.vehiclePageBanner || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
  });

  // Filter BrandLogos to exclude Eka, Altigreen, and Etrio
  const filteredBrandLogos = BrandLogos?.filter((logo) => {
    const brandName = logo?.BrandName?.toLowerCase();
    return brandName !== "eka" && brandName !== "altigreen" && brandName !== "etrio" && brandName !== "4w/eka/k1.5";
  });

  return {
    props: { 
      vehiclesByBrand: updatedVehiclesByBrand,
      itemListSchema,
      faqPageSchema,
      BrandLogos: filteredBrandLogos },
  };
};
